import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { API_URLS } from '../../models/contant';
import { Constants } from '../../models/contant';


@Injectable({
  providedIn: 'root'
})
export class BuyertinService {

  constructor(private httpClient: HttpClient) { }


  validateBuyerTin(reqData: any): Observable<any> {

    let header = new HttpHeaders({ responseType: 'json' });

    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.BUYERTIN.VALIDATE}`;

    // return of({ status: 'Valid', message: "TIN Valid" });
    return this.httpClient.post<any>(url, reqData);
  }

  submitreciept(reqData: any): Observable<any> {

    let header = new HttpHeaders({ responseType: 'json' });

    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.SUBMITRECEIPT.SUBMITRECEIPT}`;

    // return of({ status: 'Valid', message: "TIN Valid" });
    return this.httpClient.post<any>(url, reqData);
  }
  triggerOTP(sellerBrn: any,buyerEmailId:any): Observable<any> {
    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.SUBMITRECEIPT.TRIGGEROTP}`;
    let params = new HttpParams()
    params = params.append('sellerBrn', sellerBrn);
    params = params.append('buyerEmailId', buyerEmailId);

    return this.httpClient.post(url, params);
  }
  validateOTP(userOTP: any,userEmail:any): Observable<any> {
    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.SUBMITRECEIPT.VALIDATEOTP}`;
    let params = new HttpParams()
    params = params.append('userOTP', userOTP);
    params = params.append('userEmail', userEmail);
 
    return this.httpClient.post(url, params);
  }
  
}
